import {
    FETCH_MEDICINES_LIST_REQUEST,
    FETCH_MEDICINES_LIST_SUCCESS,
    FETCH_MEDICINES_LIST_FAILURE,
  } from "./FetchMedicinesListTypes";
  import api from "../../utils/Api";
  import axios from 'axios';
  
  export const fetchMedicinesListRequest = () => {
    return {
      type: FETCH_MEDICINES_LIST_REQUEST,
    };
  };
  
  export const fetchMedicinesListSuccess = (medicinesList) => {
    return {
      type: FETCH_MEDICINES_LIST_SUCCESS,
      payload: medicinesList,
    };
  };
  
  export const fetchMedicinesListFailure = (error) => {
    return {
      type: FETCH_MEDICINES_LIST_FAILURE,
      payload: error,
    };
  };
  
  const CancelToken = axios.CancelToken;
  let cancelRequest;
  export const fetchMedicinesList = (page, payload) => {
     //cancel previous request if multiple hits done.
    cancelRequest && cancelRequest();
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "medprax/medicine/list/fetch?pageSize=5&page=" + page;

    if(payload && payload.search_filter && payload.search_key){
      url += "&"+ payload.search_filter+ "=" + payload.search_key;
    }
    return async (dispatch) => {
      dispatch(fetchMedicinesListRequest);
      try {
        const response = await api.get(
          url,
          {
            headers: headers,
            cancelToken: new CancelToken(function executor(c) {
              cancelRequest = c;
          })
          }
        );
       
        const proceduresList = response.data.data;
        dispatch(fetchMedicinesListSuccess(proceduresList));
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Error: ', error.message); // => prints: Api is being canceled
        } 
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchMedicinesListFailure(errorMsg));
      }
    };
  };
  